package com.schoolconnect.app.repository.homework

import com.schoolconnect.app.datasource.network.KtorApiClient
import com.schoolconnect.app.datasource.network.response.HomeworkListResponse
import com.schoolconnect.app.datasource.network.response.TeacherHomeworkStatisticsResponse
import com.schoolconnect.app.feature.common.PaginationPolicy
import com.schoolconnect.app.util.scLog
import com.schoolconnect.app.repository.common.RepositoryCache
import com.schoolconnect.app.repository.common.tenantCacheKey
import kotlinx.coroutines.CoroutineScope

object HomeworkListRepository {
    private const val TAG = "[DATA_RETRIEVE_SC] HomeworkListRepository"
    private val pageCache = RepositoryCache<HomeworkListResponse>()

    suspend fun loadPage(
        search: String? = null,
        classSectionId: String? = null,
        subjectId: String? = null,
        status: String? = null,
        pageIndex: Int = 0,
        pageSize: Int = PaginationPolicy.DEFAULT_PAGE_SIZE,
        sortBy: String? = null,
        order: String? = null,
        forceRemote: Boolean = false,
        refreshScope: CoroutineScope
    ): Result<HomeworkListResponse> {
        val request = com.schoolconnect.app.feature.common.PageRequest(pageIndex, pageSize.coerceIn(1, 100))
        val safePageIndex = request.safePageIndex
        val safeOffset = request.offset
        val safeLimit = request.safePageSize
        scLog("$TAG loadPage start offset=$safeOffset limit=$safeLimit status=${status ?: "<any>"}")
        val key = tenantCacheKey("teacher-homework:${search.orEmpty()}:${classSectionId.orEmpty()}:${subjectId.orEmpty()}:${status.orEmpty()}:$safeOffset:$safeLimit:${sortBy.orEmpty()}:${order.orEmpty()}")
        return pageCache.load(refreshScope, TAG, "loadPage", key, forceRemote = forceRemote) {
            val result = KtorApiClient.getTeacherHomework(
                search = search,
                classSectionId = classSectionId,
                subjectId = subjectId,
                status = status,
                offset = safeOffset,
                limit = safeLimit,
                sortBy = sortBy,
                order = order
            )
            result.onFailure { throwable -> scLog("$TAG loadPage failure offset=$safeOffset", throwable) }
        }
    }

    fun invalidateCache() {
        pageCache.clear()
        scLog("$TAG invalidateCache")
    }

    suspend fun loadStatistics(): Result<TeacherHomeworkStatisticsResponse> {
        scLog("$TAG loadStatistics start")
        return KtorApiClient.getTeacherHomeworkStatistics()
            .onFailure { throwable -> scLog("$TAG loadStatistics failure", throwable) }
    }
}
